<template>
<div class="page-content margin-bottom-60">
    <div class="center-text own-title margin-bottom-20">
        {{data[loadIndex].header}}
    </div>
    <div class="content margin-bottom-10">
        <a href="/career-lifestyle-survey">
            <img :src="'images/mpower-new/career/back-arrow.png'" />
        </a>
    </div>
    <div class="content">
        <div class="career-question-title margin-bottom-20">
            {{data[loadIndex].title}}
        </div>
        <div class="career-question-desc line-height-normal">
            {{data[loadIndex].description}} 
        </div>
    </div>

    <div v-for="content in data[loadIndex].content" class="" :key="content.index">
        <div class="content">
            <div class="content">
                <div class="career-question-section line-height-normal text-left">
                    {{content.description}}
                </div>
            </div>

            <div v-for="first in content.question" class="content" :key="first.index">
                <div v-if="first.type === 'rate'">
                    <div class="career-category text-left margin-top-20 margin-bottom-20">{{ first.section }}</div>                    
                    <label id="left" class="career-radio-wrapper-text-left"  >{{content.min}}</label>
                    <label class="career-radio-wrapper" :class="first.value=='1'?'career-label-highlight':''"><input v-model="first.value" value="1" class="career-radio" type="radio" style="display: none;"/> 1</label>
                    <label class="career-radio-wrapper" :class="first.value=='2'?'career-label-highlight':''"><input v-model="first.value" value="2" class="career-radio" type="radio" style="display: none;"/> 2</label>
                    <label class="career-radio-wrapper" :class="first.value=='3'?'career-label-highlight':''"><input v-model="first.value" value="3" class="career-radio" type="radio" style="display: none;"/> 3</label>
                    <label class="career-radio-wrapper" :class="first.value=='4'?'career-label-highlight':''"><input v-model="first.value" value="4" class="career-radio" type="radio" style="display: none;"/> 4</label>
                    <label class="career-radio-wrapper" :class="first.value=='5'?'career-label-highlight':''"><input v-model="first.value" value="5" class="career-radio" type="radio" style="display: none;"/> 5</label>
                    <label id="right" class="career-radio-wrapper-text-right"  >{{content.max}}</label>
                    <div :class="first.index+ ' error-remark'"></div>
                </div>

                <div v-else-if="first.type === 'checkbox'">
                    <div class="career-question-section line-height-normal text-left margin-bottom-30">{{first.section}}</div>
                    <div v-for="answer in first.answer" class="" :key="answer.index">
                        <label class="text-left career-checkbox">
                            <input type="checkbox" :id="answer.index" :value="answer.title" v-model="first.value" :disabled="first.value.length > 2 && first.value.indexOf(answer.title) === -1" >
                            {{answer.title}}
                        </label>
                    </div>
                    <div class="clear"></div>
                    <div :class="first.index+ ' error-remark text-left'"></div>
                </div>

                <div v-else-if="first.type === 'radio'">
                    <div class="career-question-section line-height-normal text-left margin-bottom-10 margin-top-30">{{first.section}}</div>
                    <div v-for="answer in first.answer" :key="answer.index">
                        <label class="text-left career-radio">
                            <input type="radio" :id="answer.index" :value="answer.title" v-model="first.value">
                            {{answer.title}}
                        </label>
                    </div>
                    <div class="clear"></div>
                    <div :class="first.index+ ' error-remark text-left'"></div>
                </div>

                <div v-else-if="first.type === 'selection'">
                    <div class="career-question-section line-height-normal text-left margin-bottom-30 margin-top-30">{{first.section}}</div>
                    
                    <div class="checkboxes-demo">
                        <div v-for="answer in first.answer" :class="'fac option'+first.index+answer.index" :key="answer.index">
                            <input :id="'option'+first.index+answer.index" type="radio" class="career-selection" v-model="first.value" :name="first.index" :value="answer.title">
                            <label :for="'option'+first.index+answer.index"> {{answer.title}}</label>
                        </div>
                    </div>
                    <div class="clear"></div>
                    <div :class="first.index+ ' error-remark'"></div>
                </div>
                <div v-else-if="first.type === 'text'" :class="first.offset==true ?'sub-content':''">
                    <div class="career-question-section line-height-normal text-left margin-top-20 margin-bottom-20">{{first.section}}</div>
                    <input v-model="first.value" class="custom-input text-left text-area" :placeholder="first.placeholder" />
                    <div :class="first.index+ ' error-remark text-left'"></div>
                </div> 
            </div>
        </div>

        <div v-if="content.is_divider === 'true'">
            <div class="career-divider margin-top-30 margin-bottom-30"></div>
        </div>
    </div>
    <div class="talent-button-wrapper">
        <a @click="proceed()" class="generali-button-red">
            {{data[loadIndex].button}}
        </a>
    </div>
</div>
</template>
<style scoped>

input[type="checkbox"]{
   appearance: none;
   border: 1px solid #d3d3d3;
   width: 16.53px;
   height: 15px;
   content: none;
   outline: none;
   margin: 0;
   /* box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px; */
   border-radius: 20% !important;
   vertical-align: text-top;
}

input[type="checkbox"]:checked {
  appearance: none;
  outline: none;
  padding: 0;
  content: none;
  border: none;
}

input[type="checkbox"]:checked::before{
  position: absolute;
  color: green !important;
  content: "\00A0\2713\00A0" !important;
  border: 1px solid #d3d3d3;
  font-weight: bolder;
  font-size: 11px;
  border-radius: 20% !important;
}

input[type="radio"]{
   appearance: none;
   border: 1px solid #d3d3d3;
   width: 16.53px;
   height: 15px;
   content: none;
   outline: none;
   margin: 0;
   /* box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px; */
   border-radius: 20% !important;
   vertical-align: text-top;
}

input[type="radio"]:checked {
  appearance: none;
  outline: none;
  padding: 0;
  content: none;
  border: none;
}

input[type="radio"]:checked::before{
  position: absolute;
  color: green !important;
  content: "\00A0\2713\00A0" !important;
  border: 1px solid #d3d3d3;
  font-weight: bolder;
  font-size: 11px;
  border-radius: 20% !important;
}


.content {
    margin: 0px 15px;
}

.career-question-title {
    font-size: 21px;
    color: #c1210c;
    font-family: "HelveticaNeueLTStd-Bd";
}

.career-question-desc {
    font-size: 13px;
    color: #7C7B7B;
    font-family: "HelveticaNeueLTStd-Bd";
}

.career-question-section {
    font-size: 13px;
    color: #7C7B7B;
}

.error-remark{
    font-size: 9px;
    color: #c1210c !important;
}

.career-width {
  max-width: 700px;
  margin: auto;
}

.text-left{
    color: #7C7B7B;
}

.career-divider {
    background:#000000;
    height: 2px;
}

.career-category {
    font-size: 14px;
    color: #c1210c;
    font-family: "HelveticaNeueLTStd-Bd";
}

.career-checkbox, .career-radio {
    font-size: 13px;
    color: #7C7B7B;
}

/* Rate */
.career-radio-wrapper {
    /* width: calc(20% - 26px); */
    /* width:calc(20% - 22.071859999999997px); */
    display: inline-block !important;
    /* color: #7C7B7B; */
    height: 32px;
    line-height: 13.77px;
    
    padding: 10px 0;
    border: 1px solid #7C7B7B;
    font-size: 11.48px;
}
.career-radio-wrapper-text-right {
  /* width: 50px; */
  /* width: max-content; */
  max-width: 60px;
  width: auto;
  /* width: fit-content; */
  display: inline-block !important;
  color: #7C7B7B;
  padding-top: 3px;
  height: 32px;
  line-height: normal;
  padding-left: 10px;
  border: 1px solid #7C7B7B;
  font-size: 10px;
  vertical-align: -webkit-baseline-middle;
  /* padding: 0px; */
  border: none;
}
.career-radio-wrapper-text-left {
    /* width: max-content; */
    width: auto;
    max-width: 60px;
    /* width: fit-content; */
    display: inline-block !important;
    color: #7C7B7B;
    height: 32px;
    line-height: normal;
    padding-right: 10px;
    padding-top: 3px;
    border: 1px solid #7C7B7B;
    font-size: 10px;
    vertical-align: -webkit-baseline-middle;
    /* padding: 0px; */
    border: none;
}
.career-radio {
    -webkit-appearance: none !important;
}

/* text */
.sub-content{
    margin: 0px 20px 30px 20px;
}

.custom-input{
    color: #7A7B7A;
    background-color: transparent;
}

.text-area {
    /* padding: 0 10px; */
    border-bottom: 1px solid #7A7B7A;
    width: 100%;
    font-size: 13px;
}

/* selection */
.checkboxes-demo .fac {
    display: inline-block;
}
.fac>input+label:before,
.fac>span::after {
    color: transparent;
}

.fac label {
    border: 1px solid #000000;
    padding: 10px 15px;
    border-radius: 10px;
    min-width: 90px;
    /* margin-right: 15px; */
    background-color: #ffffff;
    color: #7A7B7A !important;
    font-size: 13px;
}

.fac-checkbox>input:checked+label,
.fac>input:checked+label {
    background-color: #DADAD9;
    color: #000000;
}


@media (min-width:765px){
    .career-question-title{
        font-size: 21px;
    }
    
    .career-question-section,.career-label,.career-option,.button-m,p{
        font-size: 13px;
    }

    .sub-content{
        margin: 0px 15px 30px 15px;
    }
}

</style>
<script>
import $ from 'jquery'
export default {
    name: "career_disturb",
    data(){
        return {
            conclusion: {},
            loadIndex: 0,
            data: [{
                "language": "en",
                "title": "Disturb",
                "header": " Career & Lifestyle Survey Form",
                "description": "Based on a scale of 1-5, please rate your satisfaction level towards your current job. ( 1 very dissatisfy; 5 is most satisfy )",
                "content":[
                        {
                            "description": "",
                            "question": [
                                {
                                    "index": "q1a",
                                    "section": "A. A Clear career future path",
                                    "type": "rate",
                                    "value": "0"
                                },
                                {
                                    "index": "q1b",
                                    "section": "B. Enjoy current job",
                                    "type": "rate",
                                    "value": "0"
                                },
                                {
                                    "index": "q1c",
                                    "section": "C. Good compensation",
                                    "type": "rate",
                                    "value": "0"
                                },
                                {
                                    "index": "q1d",
                                    "section": "D. Career Advancement opportunity",
                                    "type": "rate",
                                    "value": "0"
                                },
                                {
                                    "index": "q1e",
                                    "section": "E. Personal recognition",
                                    "type": "rate",
                                    "value": "0"
                                },
                                {
                                    "index": "q1f",
                                    "section": "F. Career Satisfaction",
                                    "type": "rate",
                                    "value": "0"
                                },
                                {
                                    "index": "q1g",
                                    "section": "G. Personal Development",
                                    "type": "rate",
                                    "value": "0"
                                },
                                {
                                    "index": "q1h",
                                    "section": "H. Independent & Flexibility",
                                    "type": "rate",
                                    "value": "0"
                                },
                                {
                                    "index": "q1",
                                    "section": "As a whole, how do you rate your current job?",
                                    "type": "text",
                                    "placeholder": "Your Answer",
                                    "value": "",
                                    "offset": true
                                }
                            ],
                            "min": "Dissatisfy",
                            "max": "Satisfy",
                            "is_divider": "true"
                        },
                        {
                            "description": "2. What are the 3 most important factors if you were to start a new career / job?  ",
                            "question": [
                                {
                                "index": "q2",
                                "section": "",
                                "type": "checkbox",
                                "value": [],
                                "answer": [{
                                    "index": 1,
                                    "title": "A Clear career future path",
                                    "value": 0,
                                },{
                                    "index": 2,
                                    "title": "Enjoy current job",
                                    "value": 0,
                                },{
                                    "index": 3,
                                    "title": "Good compensation",
                                    "value": 0,
                                },{
                                    "index": 4,
                                    "title": "Career Advancement opportunity",
                                    "value": 0,
                                },{
                                    "index": 5,
                                    "title": "Personal recognition",
                                    "value": 0,
                                },{
                                    "index": 6,
                                    "title": "Career Satisfaction",
                                    "value": 0,
                                },{
                                    "index": 7,
                                    "title": "Personal Development",
                                    "value": 0,
                                },{
                                    "index": 8,
                                    "title": "Independent & Flexibility",
                                    "value": 0,
                                }]
                            }],
                            "is_divider": "true"
                        },
                        {
                            "description": "",
                            "question": [
                                {
                                    "index": "q3",
                                    "section": "3. Can your current job help you to achieve these 3 factors?",
                                    "type": "selection",
                                    "value": "",
                                    "answer": [{
                                        "index": 1,
                                        "title": "Yes",
                                    },{
                                        "index": 2,
                                        "title": "No",
                                    }]
                                },
                                {
                                    "index": "q3a",
                                    "section": "If yes, how long will it takes?",
                                    "type": "text",
                                    "placeholder": "Your Answer",
                                    "value": "",
                                    "offset": true
                                }
                            ],
                            "is_divider": "false"
                        },
                        {
                            "description": "4. Given that you are free to make choices, what kind of lifestyle do you desire?",
                            "question": [
                                {
                                    "index": "q4a",
                                    "section": "House",
                                    "type": "radio",
                                    "value": "",
                                    "answer": [{
                                            "index": 1,
                                            "title": "Rent",
                                        },{
                                            "index": 2,
                                            "title": "Own(condominium)",
                                        },{
                                            "index": 3,
                                            "title": "Own(terrace)",
                                        },{
                                            "index": 4,
                                            "title": "Bungalow",
                                        }]
                                },{
                                    "index": "q4b",
                                    "section": "Car",
                                    "type": "radio",
                                    "value": "",
                                    "answer": [{
                                            "index": 1,
                                            "title": "Local",
                                        },{
                                            "index": 2,
                                            "title": "Import",
                                        },{
                                            "index": 3,
                                            "title": "Luxury",
                                        }]
                                },{
                                    "index": "q4c",
                                    "section": "Holiday",
                                    "type": "radio",
                                    "value": "",
                                    "answer": [{
                                            "index": 1,
                                            "title": "Local",
                                        },{
                                            "index": 2,
                                            "title": "Oversea",
                                        }]
                                },{
                                    "index": "q4d",
                                    "section": "Travel",
                                    "type": "radio",
                                    "value": "",
                                    "answer": [{
                                            "index": 1,
                                            "title": "2-3 years once",
                                        },{
                                            "index": 2,
                                            "title": "Every year",
                                        },{
                                            "index": 3,
                                            "title": "Multiple per year",
                                        }]
                                },{
                                    "index": "q4e",
                                    "section": "Retire",
                                    "type": "radio",
                                    "value": "",
                                    "answer": [{
                                            "index": 1,
                                            "title": "Any time",
                                        },{
                                            "index": 2,
                                            "title": "55 years old",
                                        },{
                                            "index": 3,
                                            "title": "Cannot stop",
                                        }]
                                },{
                                    "index": "q4f",
                                    "section": "Children's Education",
                                    "type": "radio",
                                    "value": "",
                                    "answer": [{
                                            "index": 1,
                                            "title": "Local",
                                        },{
                                            "index": 2,
                                            "title": "Oversea",
                                        }]
                                },{
                                    "index": "q4g",
                                    "section": "Family",
                                    "type": "radio",
                                    "value": "",
                                    "answer": [{
                                            "index": 1,
                                            "title": "Limited time",
                                        },{
                                            "index": 2,
                                            "title": "Sufficient time",
                                        }]
                                }
                            ],
                            "is_divider": "false"
                        }
                    ],
                "answer": "Yes",
                "button": "Proceed"
            },{
                "language": "cn",
                "title": "干扰",
                "header": "职业和生活方式调查表",
                "description": "根据1-5的等级，请评价您对当前工作的满意程度。（1为非常不满意；5为最满意）",
                "content":[
                    {
                        "description": "",
                        "question": [
                            {
                                "index": "q1a",
                                "section": "A. 清晰的未来职业展望",
                                "type": "rate",
                                "value": "0"
                            },
                            {
                                "index": "q1b",
                                "section": "B. 享受现在的工作",
                                "type": "rate",
                                "value": "0"
                            },
                            {
                                "index": "q1c",
                                "section": "C. 良好的薪酬待遇",
                                "type": "rate",
                                "value": "0"
                            },
                            {
                                "index": "q1d",
                                "section": "D. 晋升机会",
                                "type": "rate",
                                "value": "0"
                            },
                            {
                                "index": "q1e",
                                "section": "E. 个人认可",
                                "type": "rate",
                                "value": "0"
                            },
                            {
                                "index": "q1f",
                                "section": "F. 满意",
                                "type": "rate",
                                "value": "0"
                            },
                            {
                                "index": "q1g",
                                "section": "G. 个人发展",
                                "type": "rate",
                                "value": "0"
                            },
                            {
                                "index": "q1h",
                                "section": "H. 独立及具伸缩性",
                                "type": "rate",
                                "value": "0"
                            },
                            {
                                "index": "q1",
                                "section": "总的来说，你目前工作的评分如何",
                                "type": "text",
                                "placeholder": "您的答案",
                                "value": "",
                                "offset": true
                            }
                        ],
                        "min": "不满意",
                        "max": "很满意",
                        "is_divider": "true"
                    },
                    {
                        "description": "2. 如果您想开始新的职业/工作，现在对您来说最重要的三个因 素是什么？ 请打勾",
                        "question": [
                            {
                            "index": "q2",
                            "section": "",
                            "type": "checkbox",
                            "value": [],
                            "answer": [{
                                "index": 1,
                                "title": "清晰的未来职业展望",
                                "value": 0,
                            },{
                                "index": 2,
                                "title": "享受现在的工作",
                                "value": 0,
                            },{
                                "index": 3,
                                "title": "良好的薪酬待遇 ",
                                "value": 0,
                            },{
                                "index": 4,
                                "title": "晋升机会",
                                "value": 0,
                            },{
                                "index": 5,
                                "title": "个人认可",
                                "value": 0,
                            },{
                                "index": 6,
                                "title": "满意",
                                "value": 0,
                            },{
                                "index": 7,
                                "title": "个人发展 ",
                                "value": 0,
                            },{
                                "index": 8,
                                "title": "独立及具伸缩性",
                                "value": 0,
                            }]
                        }],
                        "is_divider": "true"
                    },
                    {
                        "description": "",
                        "question": [
                            {
                                "index": "q3",
                                "section": "3. 你目前的工作能帮助你实现这三个因素吗?",
                                "type": "selection",
                                "value": "",
                                "answer": [{
                                    "index": 1,
                                    "title": "可以",
                                },{
                                    "index": 2,
                                    "title": "不可以",
                                }]
                            },
                            {
                                "index": "q3a",
                                "section": "如果是，需要多长时间",
                                "type": "text",
                                "placeholder": "您的答案",
                                "value": "",
                                "offset": true
                            }
                        ],
                        "is_divider": "false"
                    },
                    {
                        "description": "4. 如果让你自由选择，你想要什么样的生活方式？",
                        "question": [
                            {
                                "index": "q4a",
                                "section": "房子",
                                "type": "radio",
                                "value": "",
                                "answer": [{
                                        "index": 1,
                                        "title": "租",
                                    },{
                                        "index": 2,
                                        "title": "拥有一套公寓 ",
                                    },{
                                        "index": 3,
                                        "title": "拥有一座排屋",
                                    },{
                                        "index": 4,
                                        "title": "拥有一座别墅",
                                    }]
                            },{
                                "index": "q4b",
                                "section": "汽车",
                                "type": "radio",
                                "value": "",
                                "answer": [{
                                        "index": 1,
                                        "title": "国产",
                                    },{
                                        "index": 2,
                                        "title": "进口",
                                    },{
                                        "index": 3,
                                        "title": "豪华",
                                    }]
                            },{
                                "index": "q4c",
                                "section": "旅游",
                                "type": "radio",
                                "value": "",
                                "answer": [{
                                        "index": 1,
                                        "title": "本地",
                                    },{
                                        "index": 2,
                                        "title": "国外",
                                    },{
                                        "index": 3,
                                        "title": "2-3 年一次",
                                    },{
                                        "index": 4,
                                        "title": "每年",
                                    },{
                                        "index": 5,
                                        "title": "一年几次",
                                    }]
                            },{
                                "index": "q4d",
                                "section": "旅行",
                                "type": "radio",
                                "value": "",
                                "answer": [{
                                        "index": 1,
                                        "title": "2-3 年一次",
                                    },{
                                        "index": 2,
                                        "title": "每年",
                                    },{
                                        "index": 3,
                                        "title": "一年几次",
                                    }]
                            },{
                                "index": "q4e",
                                "section": "退休",
                                "type": "radio",
                                "value": "",
                                "answer": [{
                                        "index": 1,
                                        "title": "随时",
                                    },{
                                        "index": 2,
                                        "title": "55岁",
                                    },{
                                        "index": 3,
                                        "title": "停不下",
                                    }]
                            },{
                                "index": "q4f",
                                "section": "孩子教育",
                                "type": "radio",
                                "value": "",
                                "answer": [{
                                        "index": 1,
                                        "title": "本地",
                                    },{
                                        "index": 2,
                                        "title": "海外",
                                    }]
                            },{
                                "index": "q4g",
                                "section": "家庭",
                                "type": "radio",
                                "value": "",
                                "answer": [{
                                        "index": 1,
                                        "title": "有限的时间",
                                    },{
                                        "index": 2,
                                        "title": "充足的时间",
                                    }]
                            }
                        ],
                        "is_divider": "false"
                    }
                ],
                "answer": "是",
                "button": "继续"
            },{
                "language": "bm",
                "title": "Gangguan",
                "header": "Kaji Selidik Kerjaya & Gaya Hidup",
                "description": "Berdasarkan skala 1-5, sila nilaikan tahap kepuasan anda terhadap pekerjaan semasa anda. (1 sangat tidak puas hati, 5 paling memuaskan)",
                "content":[
                    {
                        "description": "",
                        "question": [
                            {
                                "index": "q1a",
                                "section": "A. Masa depan kerjaya yang jelas",
                                "type": "rate",
                                "value": "0"
                            },
                            {
                                "index": "q1b",
                                "section": "B. Nikmati pekerjaan semasa",
                                "type": "rate",
                                "value": "0"
                            },
                            {
                                "index": "q1c",
                                "section": "C. Ganjaran yang baik",
                                "type": "rate",
                                "value": "0"
                            },
                            {
                                "index": "q1d",
                                "section": "D. Peluang kemajuan kerjaya",
                                "type": "rate",
                                "value": "0"
                            },
                            {
                                "index": "q1e",
                                "section": "E. Pengiktirafan peribadi",
                                "type": "rate",
                                "value": "0"
                            },
                            {
                                "index": "q1f",
                                "section": "F. Kepuasan hati",
                                "type": "rate",
                                "value": "0"
                            },
                            {
                                "index": "q1g",
                                "section": "G. Pembangunan Diri",
                                "type": "rate",
                                "value": "0"
                            },
                            {
                                "index": "q1h",
                                "section": "H. Berdikari & Fleksibel",
                                "type": "rate",
                                "value": "0"
                            },
                            {
                                "index": "q1",
                                "section": "Secara keseluruhan, bagaimanakah anda menilai perkerjaan semasa anda?",
                                "type": "text",
                                "placeholder": "Jawapan Anda",
                                "value": "",
                                "offset": true
                            }
                        ],
                        "min": "Tidak puas hati",
                        "max": "Paling memuaskan",
                        "is_divider": "true"
                    },
                    {
                        "description": "2. Jika anda ingin memulakan kerjaya/pekerjaan baru, yang manakah 3 faktor yang paling penting untuk anda sekarang? Silakan senaraikan",
                        "question": [
                            {
                            "index": "q2",
                            "section": "",
                            "type": "checkbox",
                            "value": [],
                            "answer": [{
                                "index": 1,
                                "title": "Masa depan kerjaya yang jelas",
                                "value": 0,
                            },{
                                "index": 2,
                                "title": "Nikmati pekerjaan semasa",
                                "value": 0,
                            },{
                                "index": 3,
                                "title": "Ganjaran yang baik",
                                "value": 0,
                            },{
                                "index": 4,
                                "title": "Peluang kemajuan kerjaya",
                                "value": 0,
                            },{
                                "index": 5,
                                "title": "Pengiktirafan peribadi",
                                "value": 0,
                            },{
                                "index": 6,
                                "title": "Kepuasan hati",
                                "value": 0,
                            },{
                                "index": 7,
                                "title": "Pembangunan Diri",
                                "value": 0,
                            },{
                                "index": 8,
                                "title": "Berdikari & Fleksibel",
                                "value": 0,
                            }]
                        }],
                        "is_divider": "true"
                    },
                    {
                        "description": "",
                        "question": [
                            {
                                "index": "q3",
                                "section": "3. Bolehkah pekerjaan anda sekarang membantu anda mencapai 3 faktor ini?",
                                "type": "selection",
                                "value": "",
                                "answer": [{
                                    "index": 1,
                                    "title": "Ya",
                                },{
                                    "index": 2,
                                    "title": "Tidak",
                                }]
                            },
                            {
                                "index": "q3a",
                                "section": "Jika ya, berapa lama masa yang diperlukan?",
                                "type": "text",
                                "placeholder": "Jawapan Anda",
                                "value": "",
                                "offset": true
                            }
                        ],
                        "is_divider": "false"
                    },
                    {
                        "description": "4. Jika anda diberi kebebasan untuk memilih, apakah gaya hidup yang anda inginkan?",
                        "question": [
                            {
                                "index": "q4a",
                                "section": "Rumah",
                                "type": "radio",
                                "value": "",
                                "answer": [{
                                        "index": 1,
                                        "title": "Sewa",
                                    },{
                                        "index": 2,
                                        "title": "Milik sendiri (kondominium)",
                                    },{
                                        "index": 3,
                                        "title": "Milik sendiri (teres)",
                                    },{
                                        "index": 4,
                                        "title": "Banglo",
                                    }]
                            },{
                                "index": "q4b",
                                "section": "Kereta",
                                "type": "radio",
                                "value": "",
                                "answer": [{
                                        "index": 1,
                                        "title": "Tempatan",
                                    },{
                                        "index": 2,
                                        "title": "Luar negara",
                                    },{
                                        "index": 3,
                                        "title": "Mewah",
                                    }]
                            },{
                                "index": "q4c",
                                "section": "Cuti",
                                "type": "radio",
                                "value": "",
                                "answer": [{
                                        "index": 1,
                                        "title": "Tempatan",
                                    },{
                                        "index": 2,
                                        "title": "Luar negara",
                                    },{
                                        "index": 3,
                                        "title": "2 –3 tahun sekali",
                                    },{
                                        "index": 4,
                                        "title": "Setiap tahun",
                                    },{
                                        "index": 5,
                                        "title": "Berganda setiap tahun",
                                    }]
                            },{
                                "index": "q4d",
                                "section": "Melancong",
                                "type": "radio",
                                "value": "",
                                "answer": [{
                                        "index": 1,
                                        "title": "2–3 tahun sekali",
                                    },{
                                        "index": 2,
                                        "title": "Setiap tahun",
                                    },{
                                        "index": 3,
                                        "title": "Berganda setip tahun",
                                    }]
                            },{
                                "index": "q4e",
                                "section": "Bersara",
                                "type": "radio",
                                "value": "",
                                "answer": [{
                                        "index": 1,
                                        "title": "Bila-bila saja",
                                    },{
                                        "index": 2,
                                        "title": "Umur 55 tahun",
                                    },{
                                        "index": 3,
                                        "title": "Tak boleh berhenti",
                                    }]
                            },{
                                "index": "q4f",
                                "section": "Pendidikan Anak",
                                "type": "radio",
                                "value": "",
                                "answer": [{
                                        "index": 1,
                                        "title": "Tempatan",
                                    },{
                                        "index": 2,
                                        "title": "Luar negara",
                                    }]
                            },{
                                "index": "q4g",
                                "section": "Keluarga",
                                "type": "radio",
                                "value": "",
                                "answer": [{
                                        "index": 1,
                                        "title": "Masa yang terhad",
                                    },{
                                        "index": 2,
                                        "title": "Masa yang mencukupi",
                                    }]
                            }
                        ],
                        "is_divider": "false"
                    }
                ],
                "answer": "Ya",
                "button": "Teruskan"
            }]
        }
    },
    mounted(){
        if(localStorage.getItem('career_test')){
            try{
                this.conclusion = JSON.parse(localStorage.getItem('career_test'))
                for(var a = 0; a < this.data.length; a++){
                    if(this.conclusion.language==this.data[a].language){
                        this.loadIndex = a
                    }
                }
            }
            catch(e){
                console.log(e)
                localStorage.removeItem('career_test')
            }
        }
      
        var left_width = [50,50,50];
        var right_width= [50,50,50];


        var each_width = ((left_width[this.loadIndex] + right_width[this.loadIndex])/5)+10;

        var width_text =  'calc(20% - ' + each_width + 'px)';

        if(this.loadIndex == 2){
                $(".career-radio-wrapper-text-left").css({
                    'vertical-align': 'middle',
                    'padding-top': '1px',
                });  

                $(".career-radio-wrapper-text-right").css({
                    'vertical-align': 'middle',
                    'padding-top': '1px',
                });  
        }

        $(".career-radio-wrapper").css({
            width: width_text,
        });        
    },
    methods: {
        proceed(){

            var status = false;
            for(var a = 0; a < this.data[this.loadIndex].content.length; a++){
                for(var d = 0; d < this.data[this.loadIndex].content[a].question.length; d++){
                    var question = this.data[this.loadIndex].content[a].question[d];

                    var error_msg = [
                        "*Please fill in the answer",
                        '*请填写答案',
                        '*Sila masukkan jawapan'
                    ];

                    if(question.value=='' || question.value==0){
                        if(question.index == 'q3a'){
                            if(this.conclusion['q3'] == 'Yes'){
                                document.querySelector("."+question.index).innerHTML = error_msg[this.loadIndex];
                                status = true;
                            }else{
                                document.querySelector("."+question.index).innerHTML = "";
                                this.conclusion[question.index] = question.value;
                            }
                        }
                        else{
                            document.querySelector("."+question.index).innerHTML = error_msg[this.loadIndex];
                            status = true;
                        }
                    }
                    
                    else if(question.index == 'q2') {
                        if(question.value.length == 3){
                            this.conclusion[question.index] = question.value;
                            document.querySelector("."+question.index).innerHTML = "";
                        }else{
                            document.querySelector("."+question.index).innerHTML = error_msg[this.loadIndex];
                            status = true;
                        }
                        }
                    else{
                        document.querySelector("."+question.index).innerHTML = "";
                        this.conclusion[question.index] = question.value;
                    }
                }
            }
            localStorage.setItem('career_test',JSON.stringify(this.conclusion))
            window.scrollTo(0,0);

            if(status == false){
                this.$router.push({path: 'career-solution'})
            } 
        },
        scrollToTop() {
            window.scrollTo(0,0);
        }
    }
}
</script>